import {Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SnackbarComponent} from "../components/snackbar/snackbar.component";
import {SnackBarData} from "../dm";

const ERROR_CLASSES = ["snack-bar", "snack-bar-error"]
const WARNING_CLASSES = ["snack-bar", "snack-bar-warning"]
const SUCCESS_CLASSES = ["snack-bar", "snack-bar-success"]
const INFO_CLASSES = ["snack-bar", "snack-bar-info"]

@Injectable()
export class NotificationService {
  constructor(
    private readonly snackBar: MatSnackBar
  ) { }

  showErrorMessage(message: string, durationMs = 15_000) {
    this.showMessage(message, ERROR_CLASSES, durationMs)
  }

  showSuccessMessage(message: string, durationMs = 15_000) {
    this.showMessage(message, SUCCESS_CLASSES, durationMs)
  }

  showInfoMessage(message: string, durationMs = 10_000) {
    this.showMessage(message, INFO_CLASSES, durationMs)
  }

  showWarningMessage(message: string, durationMs = 15_000) {
    this.showMessage(message, WARNING_CLASSES, durationMs)
  }

  private showMessage(message: string, panelClasses: string[], durationMs: number) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: durationMs,
      panelClass: panelClasses,
      data: {
        message: message
      } as SnackBarData
    })
  }
}
